// Caches the array projection of a Map so unrelated re-renders (renders
// that don't follow a merge) get the same array reference back, instead of
// a fresh Array.from() every call. Keying the cache by the Map instance
// itself means it's invalidated for free whenever a store replaces its Map.
export function createMapArrayCache<K, V>() {
  const cache = new WeakMap<Map<K, V>, V[]>();

  return (map: Map<K, V>): V[] => {
    let cached = cache.get(map);
    if (!cached) {
      cached = Array.from(map.values());
      cache.set(map, cached);
    }
    return cached;
  };
}
